import React from "react";
import ArrayBars from "../ArrayBars/ArrayBars";
import ControlBar from "../ControlBar/ControlBar";

function SortingVisualizer() {
    return (
        <div>
            <ControlBar />
            <ArrayBars />
        </div>
    );
}

export default SortingVisualizer;